<template>
  <!-- paper header info -->
  <div class="paper-info" :class="{ 'pop-paper-info': isPopWithDialog }">
    <div class="paper-detail-info">
      <div class="info-title">
        <p class="title">{{ info.paperTitle }}</p>
      </div>
      <div class="detail-info" v-if="detailInfoList.length">
        <div class="info" v-for="item in detailInfoList" :key="item">
          {{ item }}
        </div>
        <el-tooltip effect="light" placement="bottom-start">
          <div slot="content">
            <div class="tip-card">
              <div class="item" v-for="item in moreInfoList" :key="item.label">
                <div class="label">
                  <span class="label-name">{{ item.label }}</span>
                  <span>：</span>
                </div>
                <div class="value">{{ item.value }}</div>
              </div>
            </div>
          </div>
          <div class="more-info" v-if="!isComposePaper">
            更多
            <i class="iconfont icon-down-arrow"></i>
          </div>
        </el-tooltip>
        <div class="shezhi btn" data-io-click="tracker"  @click="openSetDialog()" v-if="isPopWithDialog">
          <i class="iconfont icon-shezhi"></i><span>打开方式</span>
        </div>
      </div>
    </div>
    <div class="paper-operation" v-if="!isPopWithDialog">
      <!-- 挑错 -->
      <!--      <div class="tiaocuo-btn btn" data-io-click="tracker"  @click="handleFeedbackDialogVisible(true)">-->
      <!--        <i class="iconfont icon-edit"></i><span>挑错</span>-->
      <!--      </div>-->
      <!-- 打开方式 -->
      <div class="shezhi btn" data-io-click="tracker"  @click="openSetDialog()">
        <i class="iconfont icon-shezhi"></i><span>打开方式</span>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  inject: ["textbook", "isPopWithDialog"],
  name: "paperInfo",
  components: {},
  mixins: [],
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isRecomposed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isComposePaper: false,
      setDialogVisible: false,
      feedbackDialogVisible: false,
    };
  },
  computed: {
    detailInfoList: function () {
      const { addTime, versionName } = this.info;
      const list = ["来源：组卷网"];
      if (addTime) {
        list.push(`日期：${moment(addTime).format("YYYY-MM-DD")}`);
      }
      if (versionName && !this.isComposePaper) {
        list.push(versionName);
      }
      return list;
    },
    moreInfoList: function () {
      const {
        versionName,
        labelName,
        sceneName,
        year,
        difficultyName,
        zjPaperId,
      } = this.info;
      return [
        {
          label: "编号",
          value: zjPaperId,
        },
        {
          label: "标签",
          value: `${versionName} ${labelName} ${sceneName} ${year} ${difficultyName}`,
        },
        {
          label: "贡献者",
          value: "组卷网",
        },
        {
          label: "提示",
          value: "独家版权，侵权必究",
        },
      ];
    },
  },
  watch: {
    isRecomposed(val) {
      if (val) {
        this.isComposePaper = true;
      }
    },
  },
  created() {
    this.isComposePaper =
      !this.isPopWithDialog && "isCompose" in this.$route.query;
  },
  mounted() {},
  methods: {
    openSetDialog() {
      this.$emit("openSetDialog");
    },
    handleFeedbackDialogVisible() {
      this.$emit("openFeedbackDialog");
    },
  },
};
</script>
<style lang="scss">
.tip-card {
  .item {
    .label {
      display: flex;
      justify-content: space-between;
      .label-name {
        min-width: 52px;
        text-align: justify;
        text-align-last: justify;
        margin-right: 4px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.paper-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background: transparent;
  padding: 20px;
  padding-bottom: 10px;
  .btn {
    display: flex;
    align-items: center;
    border-radius: 4px;
    padding: 4px 6px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: #1a1a1a;
    &:hover {
      background: #eff1f4;
      color: #0057ff;
    }
    .iconfont {
      margin-right: 4px;
    }
  }
  &.pop-paper-info {
    padding-top: 8px;
    .detail-info {
      position: relative;
      .shezhi {
        position: absolute;
        right: 0;
        background: #f6f6f6;
      }
    }
  }
  .paper-detail-info {
    flex: 1;
    .info-title {
      margin-bottom: 5px;
      gap: 8px;
      display: flex;
      .title {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
      }
    }
    .detail-info {
      display: flex;
      align-items: center;
      gap: 24px;
      .info,
      .more-info {
        font-size: 12px;
        font-weight: 400;
        line-height: 28px;
        color: #7e7e7e;
      }
      .more-info {
        display: flex;
        align-items: center;
        gap: 3px;
        &:hover {
          .iconfont {
            transform: rotate(180deg);
          }
        }
        .iconfont {
          font-size: 10px;
        }
      }
    }
  }
  .paper-operation {
    display: flex;
    align-items: flex-end;

    .shezhi {
      margin-left: 24px;
    }
  }
}
</style>
